<template lang="pug">
    .page.page-index
        .content-box
            h2 Content will be available soon.
            h3 In the meantime, some seak peeks provided below.
            a(href='https://www.youbike-map.steven-chou.com') YouBike Map
</template>

<script>
export default {
    name: "Home",
    components: {}
};
</script>

<style scoped lang="sass">
.page-index
    height: 100vh
    background-color: black
    text-align: center
    position: relative

    .content-box
        color: white
        margin: 0
        position: absolute
        top: 50%
        left: 50%
        transform: translate(-50%, -50%)

        a
            color: white
</style>